import { create } from 'zustand';
import sentEmailsService from '../api/services/sentEmails.service';

/* Sent-email history, per network. The send itself happens through the user's
   Gmail; Compose Email writes the record, and both it and the dashboard read
   this list back from the API. */
const useEmailStore = create((set, get) => ({
  sentEmails: [],
  sentEmailsLoading: false,
  sentEmailsTotal: 0,
  sentEmailsTotalPages: 1,

  loadSentEmails: async (networkId, { page = 1, limit = 10 } = {}) => {
    if (!networkId) return;
    set({ sentEmailsLoading: true });
    try {
      const r = await sentEmailsService.list(networkId, { page, limit });
      set({
        sentEmails: r.emails,
        sentEmailsTotal: r.total,
        sentEmailsTotalPages: r.totalPages,
      });
    } finally {
      set({ sentEmailsLoading: false });
    }
  },

  /* Put a just-sent email at the top without waiting for a refetch. */
  prependSentEmail: (email) =>
    set({
      sentEmails: [email, ...get().sentEmails],
      sentEmailsTotal: get().sentEmailsTotal + 1,
    }),
}));

export default useEmailStore;
